<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-col cols="12" lg="6" md="6">
          <v-text-field label="Nama member" v-model="user.member.membername"></v-text-field>
          <v-text-field disabled label="EMail" v-model="user.member.memberemail"></v-text-field>
          <v-text-field label="Kontak Telegram/Whatsapp" v-model="user.member.membercontact"></v-text-field>
          <v-text-field required :rules="phonerules" :disabled="user.verifyphone" label="No Telp" v-model="user.member.memberphone"></v-text-field>
          <v-text-field label="Alamat" v-model="user.member.memberaddress"></v-text-field>
          <v-select
              label="Provinsi"
              item-text="provincename"
              item-value="provinceid"
              v-model="user.member.provinceid"
              :items="province"
              @change="changeprovinsi"
              persistent-hint
              return-object
          ></v-select>
          <v-select
              label="Kabupaten / Kota"
              item-text="cityname"
              item-value="cityid"
              v-model="user.member.cityid"
              :items="city"
              persistent-hint
              return-object
              @change="changecity"
          ></v-select>
          <v-select
              label="Kecamatan"
              item-text="districtname"
              item-value="districtid"
              v-model="user.member.districtid"
              :items="district"
              persistent-hint
              return-object
              @change="changekecamatan"
          ></v-select>
        </v-col>
      </v-form>
    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-col cols="12" lg="6" md="6">
        <v-btn text @click="simpan" class="primary"><v-icon class="mr-2">save</v-icon>Simpan</v-btn>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SettingProfile',
  data: () => ({
    otp: '',
    normal: true,
    timerotp: 60,
    valid: false,
    provinceid: 0,
    phonerules: [
      v => !!v || 'Nomor Telp Belum Diisi',
      v => v.length >= 10 || 'Nomor Telp Tidak valid'
    ]
  }),
  mounted () {
    this.getProvince()
    this.$refs.form.validate()
  },
  computed: {
    ...mapState('authentication', ['user', 'accountlengkap']),
    ...mapState('UtilsStore', ['province', 'city', 'district'])
  },
  methods: {
    ...mapActions('authentication', ['getme']),
    ...mapActions('UserStore', ['updateProfile']),
    ...mapActions('UtilsStore', ['getProvince', 'getCity', 'getDistrict']),
    changeprovinsi (e) {
      console.log(e.provinceid)
      this.getCity(e.provinceid)
    },
    changecity (e) {
      // this.$store.commit('Loan/setCity', e)
      this.getDistrict(e.cityid)
    },
    changekecamatan (e) {
      // this.$store.commit('Loan/setKecapatan', e)
      console.log(e)
    },
    simpan () {
      console.log(this.user.member)
      const newmember = this.user.member
      const districtid = this.user.member.districtid.districtid
      newmember.districtid = districtid

      if (typeof this.user.member.provinceid.provinceid !== 'undefined') {
        var provid = this.user.member.provinceid.provinceid
        newmember.provinceid = provid
      }

      if (typeof this.user.member.cityid.cityid !== 'undefined') {
        var cityid = this.user.member.cityid.cityid
        newmember.cityid = cityid
      }

      this.updateProfile(newmember)
    }

  }
}
</script>

<style scoped>

.borderkotak {
  border: thin solid rgba(0,0,0,.12);
}
.panelprofileimage {
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.imageavatar {
  position: relative;
  border: 2px solid rgba(0,0,0,.12);
  border-radius: 50%;
  width: 125px;
  justify-content: center;
  text-align: center;
  overflow: auto;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}
.imageavatar:hover {
  background-color: rgba(0,0,0,.5);
  z-index: 10
}
.imageavatar img {
  z-index: 0;
  position: relative;
  justify-content: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
</style>
